import type { IconSetDefinitions } from '@hotjar/hotsauce/build/components/Icon/icons';

const ICONS_MAP = {
  recordings: 'recordings',
  surveys: 'surveys',
  feedback: 'feedback',
  heatmaps: 'heatmaps',
} as const;

interface ForYouExperimentWidgetHeaderConfig {
  variant: 'l' | undefined;
  icon: keyof IconSetDefinitions | undefined;
}

export const getForYouExperimentWidgetHeaderConfig = (
  widgetId: keyof typeof ICONS_MAP,
  inExperiment?: boolean,
): ForYouExperimentWidgetHeaderConfig => {
  return {
    variant: inExperiment ? 'l' : undefined,
    icon: inExperiment ? ICONS_MAP[widgetId] : undefined,
  };
};
